import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

class ResetOtpModalStateAction extends BaseAction<void, void> {
  override async run(): Promise<void> {
    updateRecoilState("isOtpVerifiedAtom", false);
    updateRecoilState("otpErrorAtom", "");
    updateRecoilState("phoneVerificationResponseAtom", null);
  }
}

export const resetOtpModalStateAction = new ResetOtpModalStateAction(); 